module.exports = __webpack_public_path__ + "static/img/49.c881faa6.gif";